import { render } from "./server.vue?vue&type=template&id=158d105b&scoped=true"
import script from "./server.vue?vue&type=script&lang=js"
export * from "./server.vue?vue&type=script&lang=js"

import "./server.vue?vue&type=style&index=0&id=158d105b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158d105b"]])

export default __exports__